/**
 * The partner a new service profile should be named after.
 *
 * `companiesAndPartners` is populated by the navbar's company navigation list,
 * which is not fetched on every page — landing straight on Service Profiles can
 * leave it empty, and the profile then saves without the partner prefix every
 * other profile carries. The persisted company record names the same partner
 * and survives a reload, so it backs the lookup up.
 *
 * @param {object} nav `state.navigationLists`
 * @returns {string} The partner name, or '' when nothing resolves it.
 */
export const resolvePartnerName = ({
    companiesAndPartners,
    currentCompanyData,
    currentPartner,
} = {}) =>
    companiesAndPartners?.find(({ id }) => id === currentPartner)?.name ||
    currentCompanyData?.partnerName ||
    (currentCompanyData?.id === currentPartner
        ? currentCompanyData?.name
        : '') ||
    '';
